@if(isLoading()) {

}@else {
    <p-button
    [link]="true"
    severity="secondary"
    icon="pi pi-bell"
    size="small"
    [badge]="unreadNotifications.length ? unreadNotifications.length.toString() : ''"
    (onClick)="not.toggle($event)"
  />
    <p-popover #not (onHide)="markNotificationsAsRead()">
        <h3 class="font-semibold mb-3">Notificaciones</h3>
        <p-selectbutton [options]="stateOptions"
        [allowEmpty]="false"
        [(ngModel)]="value" optionLabel="label" optionValue="value" aria-labelledby="basic" />
        <div class="flex flex-col mt-2">
        @if(value === 'unread') {
            @if(unreadNotifications.length === 0) {
                    <p-message severity="info">No tienes notificaciones sin leer</p-message>
            } @else {
                @for (un of unreadNotifications; track $index) {
                    <div class="flex flex-row">
                        <div class="col-fixed">
                          <i
                            [ngClass]="{
                              'ri-edit-2-line': un.type === 'contract',
                              'ri-crosshair-2-line': un.type === 'cta',
                              'ri-error-warning-line': un.type === 'action'
                            }"
                          ></i>
                        </div>
                        <div class="col">{{ un.content }}</div>
                      </div>
                      <p-divider></p-divider>
                }
            }

        } @if (value === 'read') {
            @for (rn of readNotifications; track $index) {
                <div class="flex flex-row">
                    <div class="col-fixed">
                      <i
                        [ngClass]="{
                          'ri-edit-2-line': rn.type === 'contract',
                          'ri-crosshair-2-line': rn.type === 'cta',
                          'ri-error-warning-line': rn.type === 'action'
                        }"
                      ></i>
                    </div>
                    <div class="col">{{ rn.content }}</div>
                  </div>
                  <p-divider></p-divider>
            }
        }
        </div>
      </p-popover>
}